import { ImBlocked } from "react-icons/im";
import { useModalAvisoBloqueo } from "./modalAvisoBloqueoHooks";
import type { ModalAvisoBloqueoProps } from "./types";

export const ModalAvisoBloqueo = (props: ModalAvisoBloqueoProps) => {
  const { mensajes } = useModalAvisoBloqueo(props);

  return (
    <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto text-sm">
        <ImBlocked className="mx-auto text-red-800" size={120} />
        <h2 className="text-center text-red-600 text-3xl font-semibold">
          CUENTA BLOQUEADA
        </h2>

        {mensajes.map((mensaje) => (
          <p key={mensaje} className="text-center font-semibold text-base">
            {mensaje}
          </p>
        ))}
      </div>
    </div>
  );
};
